import { isStoreResetError } from "./isStoreResetError";

// resetStore() only refetches observable queries, so a one-shot client.query() cancelled by it is
// gone for good unless something re-reads it. By the time the cancellation reaches us the reset has
// already cleared the cache and the new token is in place, so re-running once returns fresh rows.
export const retryAfterStoreReset = async <T>(run: () => Promise<T>): Promise<T> => {
  try {
    return await run();
  } catch (error) {
    if (isStoreResetError(error)) return run();
    throw error;
  }
};
